import useSWR from "swr";

import { ACCOUNTS_KEY, listAccounts } from "@/features/accounts/api/accountsApi";
import type { Account } from "@/features/accounts/types";
import { toErrorMessage } from "@/lib/swr";

const EMPTY: Account[] = [];

export function useAccounts() {
  const { data, error, isLoading, mutate } = useSWR(ACCOUNTS_KEY, listAccounts);

  return {
    accounts: data ?? EMPTY,
    isLoading,
    error: toErrorMessage(error),
    refresh: mutate,
  };
}
